import { Component, AfterViewInit } from '@angular/core';

import { EventService } from '../core/services/event.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html'
})

export class LayoutComponent implements AfterViewInit {

    // The full-screen grid menu behind the topbar's grid button (it replaced the sidebar)
    menuOpen = false;

    constructor(private eventService: EventService) { }

    ngAfterViewInit() {
        document.body.setAttribute('data-layout', 'topnav');
    }

    onSettingsButtonClicked() {
        console.log('Settings clicked');
    }
}
